import styled from 'styled-components';

export const OrderFilterStatusStyle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
